module.exports = __webpack_public_path__ + "img/report3-3.630b62f2.png";